export const RECEIVE_PAGES = 'RECEIVE_PAGES';

export const receivePages = (pages) => {
    return (dispatch) => {
        dispatch({
            type: RECEIVE_PAGES,
            data: pages
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/PagesAction.js